export const getReferenceAccountData = (bankAccounts) => bankAccounts
  .filter((account) => account.account_type === 'checkacc' && account.BIC_data)
  // .filter((account) => account.account_type === 'checkacc')
  .map((item) => ({
    // id: Number.parseInt(item.id, 10),
    id: String(item.id),
    account_no: item.account_no,
    BIC: item.BIC_data.BIC,
    currency: item.currency,
    currency_detail: item.currency_detail,
    // org_name: `${item.BIC_data.org_name.substring(0, 10)}...`,
    org_name: item.BIC_data.org_name ? `${item.BIC_data.org_name.substring(0, 10)}...` : '',
  }));


